import React from 'react';

import { FullscreenLoader } from 'src/components/common';
import { useVerifierById, useVerifierParamId } from 'src/hooks/verifier';

import {
  CommercialVerifierCompanyInformationForm,
  GovernmentVerifierCompanyInformationForm,
} from './VerifierCompanyInformationForm';

export const VerifierCompanyInformationFormWrapperClearVerifyAdmin: React.FC = () => {
  const verifierId = useVerifierParamId();
  const { isCommercialVerifier, loading } = useVerifierById(verifierId);

  if (loading) {
    return (
      <FullscreenLoader
        sx={{
          height: '500px',
        }}
      />
    );
  }

  return isCommercialVerifier ? (
    <CommercialVerifierCompanyInformationForm verifierId={verifierId} />
  ) : (
    <GovernmentVerifierCompanyInformationForm verifierId={verifierId} />
  );
};
